
import * as yup from 'yup';
import { useFormik } from "formik";
import UseGetDataSearchByPro from "../../../Components/Hooks/useFetchDataByPRO";

import SearchBar from "../../../Components/Utils/SearchBar";
import { CancelButton, ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton, SubmitButton } from "../../../Components/Utils/Buttons";
import { GetRole } from "../../../Components/Utils/roles";
import CustomDataTable from "../../../Components/Others/CustomDataTable";
import EmployeeCard from "./EmployeeCard";
import Pagination from "../../../Components/Utils/Pagenation";
import ImportEmployee from "./import";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import useFetchMetaStarIndex from "../../../Components/Hooks/useFetchMetaStarIndex";
import useFetchMDIndex from "../../../Components/Hooks/useFetchMDIndex";
import Breadcrumb from '../../../Components/Utils/Breadcrumb';
import List from '../../../Components/Icons/list';
import Card from '../../../Components/Icons/card';
import UseGetDataSearchByProUser from '../../../Components/Hooks/useFetchDataByPROUser';
import UseGetDataSearch from '../../../Components/Hooks/useFetchDataBySearch';
import CloseIcon from '../../../Components/Icons/Close';
import axiosInstance from '../../../Services/axiosCommon';
import NuDate from '../../../Components/Utils/NuDate';
import FormikSelectTwo from '../../../Components/Utils/Select';
import MultiEditProject from './MultiEditProject';


function Employeesindex() {
   const [open, setOpen] = useState(false);
   const location = useLocation();
   const state = location.state;
  const {officeId}=useParams();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const [page, setPage] = useState(currentPage||1)
   const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [filter, setFilter] = useState(state?.industry?true:false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
    const [filterProps, setFilterProps] = useState({
    
    type:"",
   
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    // search:searchQuery||"",

    // searchBy: "",
    // country:"",
    // // category:state?.category? state.category :"",

    // category:"",
    // paymentTerm:"",
    // ratings:"",
    // status:"",
    // industry:state?.industry? state.industry :"",
    type:"",
    // approvalStatus:"",

  });
  const clearFilter = ()=> {
    setParams({...params, 

    type:""})
      formik.values.type=""
         setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,type:value.type})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
       
        type:"",
      
      });
    }
  })

  
  const { data, totalCount, getData,dataLoading } = UseGetDataSearchByProUser( `/employees/${officeId}/details`, params );
  const [viewMode, setViewMode] = useState(localStorage.getItem("viewMode") || "card");
  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "employeeId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: " Name",
      width: "10%",
      isLink: true,
      id: "employeeId",
      link: `/main/${officeId}/employees/view/`,
      field: "name",
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Email ",
      width: "10%",
      type: "email",
      field: "email",
      textAlign: "center",
      rowAlign: "center",
    },
    
    {
      title: "Mobile ",
      width: "10%",
      field: "mobileNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Gender ",
      width: "10%",
      field: "gender",
      isGender:true,
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "City ",
      width: "10%",
      field: "city",
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"employeeId",
        removeValue:"firstName",
        url:`/employees/`,
        moduleName:"Employee",
        from:`/main/${officeId}/employees/`,
        editLink:`/main/${officeId}/employees/edit/`,
        viewLink:`/main/${officeId}/employees/view/`

      }
    },
  ];
  const availableHeaders = [
   
  ];
  useEffect(()=>{
    localStorage.setItem("viewMode", viewMode);
     setParams({...params,page:page,per_page:pageCount})
 },[page,pageCount,viewMode])

 const closeFilterDialog = () => {
  setShowFilterDialog(false);
};
const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [showExport, setShowExport] = useState(false);
  const [exportValue, setExportValue] = useState({
    type: "all",
    approvalStatus: "",
    salesPerson: "",
    status: "",
    leadTime: "",
    validity: "",
    availability: "",
    paymentMethod: "",
    paymentTerms: "",
    deliveryTerms: "",
    fromDate: "",
    toDate: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {

      try {
        const response = await axiosInstance.get(`/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`, {
            responseType: 'blob' // Important to specify the response type as blob
        });

        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a link element
       
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${NuDate({value:new Date(), format:"DD-MMM-YYYY"})}.xlsx`; // The filename you want for the downloaded file

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);

    } catch (error) {
        console.error('Error downloading the PDF:', error);
    }
    },
  });
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };


      const [showEdit, setShowEdit] = useState(false)
      const [listofNumbers, setListofNumbers] = useState([])
      const [fullList, setFullList] = useState([])
    
      const selectOneFunction = (value) =>{ 
        console.log("sss",value);
       
        let NewId;
        if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
          NewId = listofNumbers.filter(Temp=> Temp !== value);
          setListofNumbers(NewId)
        }else{
          setListofNumbers([...listofNumbers,value])
        }
        console.log("sss",listofNumbers);
      }
    
      const selectMultipleFunction = (e) =>{ 
    if(e.target.checked){
      console.log("if List",fullList);
      setListofNumbers(fullList)
    }else{
      console.log("else List",fullList);
      setListofNumbers([])
    }
    
      }
    
      useEffect(()=>{
        let tempArr = []
        data && data.forEach(i=>{
          console.log("I",i);
          tempArr.push(i?.employeeId)
        });
        setFullList(tempArr)
      },[data])


  return (
    <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-end items-center'>
        {/* <Breadcrumb
         items={[
          {
            name: "Employee",

          },
        

          ]} /> */}
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />
          <div className='flex gap-2'>
            <div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
            <div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
          </div>
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <ClearFilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
            <ImportButton handleClick={handleImportClick} />
            {/* <ExportButton handleClick={() => setShowExport(true)}/> */}
             <Link to={`/main/${officeId}/employees/create`}><CreateButton label='Employee' /></Link>

        </div>
      </div>
      {viewMode === "list" ? (
      <CustomDataTable 
        fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-145px)]'
        total={totalCount}
        pageIndex={params.page}
        setPageIndex={setPage}
        dataCount={params.per_page}
        setDataCount={setPageCount}
        // title='Employee List'
        storageName="EmployeeTable"
        editAccess="employees_edit"      
        deteleAccess="employees_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}
        hasMultiEdit={true}
        selectOneFunction={selectOneFunction}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById='employeeId'
        />
      ) : (
        <>
        <div className='w-full h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll'>
       <div className='flex gap-40'>
      
        <p className='text-xs font-semibold text-[#111537] text-left'>Employee : {totalCount}</p>
        {/* <p className='text-sm'>Credit : {}</p>
         <p className='text-sm'>Advance : {}</p>
         */}

       
        </div>
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            
            {data && data.map((item, idx) => (
              <EmployeeCard fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
       {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter </h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                  
                    <FormikSelectTwo
              label="Type"
              Options={[
                { value: 1, label: "Own" },
                { value: 2, label: "Rental" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full"
            />
                     
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
         
      {showEdit && (<MultiEditProject data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
          {showImportModal && (<ImportEmployee show={showImportModal} onClose={closeModal} getData={getData} />)}
          {/* <ImportEmployee
        open={open}
        onCancel={() => setOpen(false)}
        getData={getData}
        officeId={officeId}
        label="Import"
      />    */}
          </div>
  )
}
 
export default Employeesindex